import styled from 'styled-components';
import {device} from 'styled/device';
import MobileNavigation from '../../components/acommon/MobileNavigation';
import {DesktopBackButton} from '../../components/Button';

export const StyledPage = styled.div`
  display: flex;
  flex-direction: column;
  /* align-items: center; */
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 80px;

  .filterRow {
    padding: 20px 0 0 0;
    justify-content: space-between;
    border-bottom: 1px solid #e6e8ec;

    @media (max-width: ${device.tablet}) {
      display: none;
    }
  }

  .pageHeaderRow {
    position: relative;
  }

  @media (max-width: ${device.tablet}) {
    padding: 0 20px;
  }

  @media (max-width: ${device.tablet}) {
    padding: 0 24px;

    .pageHeaderRow {
      display: none;
    }

    .filterRow {
      border: 0;
      padding: 11px 0;
    }
  }
`;

export const Catalog = styled.div`
  display: grid;
  grid-template: 1fr 1fr/ 1fr 1fr;
  row-gap: 30px;
  column-gap: 30px;

  @media (max-width: ${device.laptopM}) {
    grid-template: 1fr/ 1fr;
    margin: 0 auto;
  }

  @media (max-width: ${device.mobileM}) {
    display: flex;
    flex-direction: column;
  }
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  .leftSideOfRow {
    display: flex;
    margin-bottom: 15px;
    align-items: center;
  }

  img {
    border-radius: 25px;
    width: 100%;
  }

  @media (max-width: ${device.tablet}) {
    .leftSideOfRow {
      display: none;
    }
  }
`;

export const Col = styled.div`
  display: flex;
  flex-direction: column;
`;

export const UpsellingDesktopBackButton = styled(DesktopBackButton)`
  padding: 0;
  position: absolute;
  top: 42px;
  left: -138px;
  z-index: 2;

  @media (max-width: ${device.laptopL}) {
    left: 15px;
  }

  @media (max-width: ${device.laptop}) {
    top: 10px;
  }
`;

export const Header = styled(Col)`
  position: absolute;
  display: flex;
  align-content: center;
  padding: 0 30px;
`;

export const Title = styled.div`
  font-size: 66px;
  font-weight: bold;
  color: #353945;
  line-height: 1;

  @media (max-width: ${device.tablet}) {
    font-size: 33px;
  }
`;

export const SubTitle = styled.div`
  font-size: 26px;
  letter-spacing: -0.48px;
  margin-top: 5px;
  color: #353945;

  @media (max-width: ${device.tablet}) {
    font-size: 16px;
  }
`;

export const Off25 = styled.div`
  border: 2px solid #32d7be;
  border-radius: 4px;
  /* height: 25px; */
  color: #32d7be;
  font-size: 12px;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 6px 12px;

  @media (max-width: ${device.mobileM}) {
    border: 3px solid #32d7be;
    font-size: 18px;
    padding: 4px 12px;
  }
`;

export const CategoriesMenu = styled.div`
  cursor: pointer;
`;

export const UpsellingMobileNavigation = styled(MobileNavigation)`
  display: none;
  padding: 30px 24px 48px;

  @media (max-width: ${device.tablet}) {
    display: flex;
  }
`;
